__turbopack_context__.v({
  "container": "Arbeidsforhold-module__DzHpja__container",
  "datoAlert": "Arbeidsforhold-module__DzHpja__datoAlert",
  "datoBlokk": "Arbeidsforhold-module__DzHpja__datoBlokk",
  "detaljerBoks": "Arbeidsforhold-module__DzHpja__detaljerBoks",
  "detaljerHeader": "Arbeidsforhold-module__DzHpja__detaljerHeader",
  "detaljerIkon": "Arbeidsforhold-module__DzHpja__detaljerIkon",
  "detaljerInnhold": "Arbeidsforhold-module__DzHpja__detaljerInnhold",
  "detaljerKortliste": "Arbeidsforhold-module__DzHpja__detaljerKortliste",
  "detaljerTabell": "Arbeidsforhold-module__DzHpja__detaljerTabell",
  "detaljerTittel": "Arbeidsforhold-module__DzHpja__detaljerTittel",
  "endringerBryter": "Arbeidsforhold-module__DzHpja__endringerBryter",
  "gruppeSkille": "Arbeidsforhold-module__DzHpja__gruppeSkille",
  "oppsummeringBoks": "Arbeidsforhold-module__DzHpja__oppsummeringBoks",
  "oppsummeringInnhold": "Arbeidsforhold-module__DzHpja__oppsummeringInnhold",
  "oppsummeringKort": "Arbeidsforhold-module__DzHpja__oppsummeringKort",
  "oppsummeringKortSmal": "Arbeidsforhold-module__DzHpja__oppsummeringKortSmal",
  "rapporteringBoks": "Arbeidsforhold-module__DzHpja__rapporteringBoks",
  "skille": "Arbeidsforhold-module__DzHpja__skille",
});
